import { useContext } from 'react';

import { ModalMenuContext } from '../context/ModalMenuContext';

export const useModalMenuContext = () => {
  const context = useContext(ModalMenuContext);

  if (!context) {
    throw new Error(
      'useModalMenuContext must be used within a Modal with defaultKey'
    );
  }

  return context;
};
